import { ISignatureButtonControl } from '@infotech-soe/metaschema';

import {
  FormControlViewModelType,
  SignatureButtonFormControlViewModel,
} from '../../view-model/FormControlViewModel';

const buildSignatureButtonControl = async (
  item: ISignatureButtonControl,
  label: string
): Promise<SignatureButtonFormControlViewModel> => {
  const result: SignatureButtonFormControlViewModel = {
    columns: item.columns,
    type: FormControlViewModelType.SIGNATURE_BUTTON,
    hasValue: false,
    hasHistory: false,
    name: item.name,
    label,
    disabled: item.disabled,
    visible: item.visible,
    variant: item.variant,
    documentControl: item.documentControl,
    signatureControl: item.signatureControl,
    signatureType: item.signatureType,
  };
  return result;
};

export default buildSignatureButtonControl;
